import { render, staticRenderFns } from "./lp-drawer.vue?vue&type=template&id=3b7d66b8&"
import script from "./lp-drawer.vue?vue&type=script&lang=js&"
export * from "./lp-drawer.vue?vue&type=script&lang=js&"
import style0 from "./lp-drawer.vue?vue&type=style&index=0&id=3b7d66b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports